import { library } from '@fortawesome/fontawesome-svg-core';
import { faSquare } from '@fortawesome/free-solid-svg-icons';
import { faSquare as faSquareO } from '@fortawesome/free-regular-svg-icons';

library.add(faSquare, faSquareO);